
/**
 * Result of checking whether a nudge should be shown to the user.
 */
export class NudgeCheckResult {

    public static readonly SHOW = new NudgeCheckResult("show", "Show");
    public static readonly SKIP = new NudgeCheckResult("skip", "Skip");
    public static readonly NOT_CONSIDERED = new NudgeCheckResult("not_considered", "Not Considered");

    static values(): NudgeCheckResult[] {
        return [
            NudgeCheckResult.SHOW,
            NudgeCheckResult.SKIP,
            NudgeCheckResult.NOT_CONSIDERED,
        ];
    }

    private readonly id: string;
    private readonly name: string;

    private constructor(id: string, name: string) {
        this.id = id;
        this.name = name;
    }

    getID(): string {
        return this.id;
    }

    getName(): string {
        return this.name;
    }

    static getByID(id: string): NudgeCheckResult {
        for (const result of NudgeCheckResult.values()) {
            if (result.id === id)
                return result;
        }
        throw new Error(`Unknown nudge check result: ${id}`);
    }

    static getByIDOrNull(id: string | null): NudgeCheckResult | null {
        if (id === null)
            return null;
        for (const result of NudgeCheckResult.values()) {
            if (result.id === id)
                return result;
        }
        return null;
    }
}
